/**
 * `account_channel.hosting_name` 의 어휘.
 *
 * ## 값의 층위
 *
 * **'오모플레이' 와 '쇼핑몰' 이 같은 레벨**이고, 카페24·아임웹·식스샵·고도몰·독립몰은
 * 그 아래 '쇼핑몰' 의 종류다. 종전에는 상위 구분이 없어서 **오모플레이 제공 자사몰을
 * 표현할 값이 아예 없었다** — 그래서 온보딩 화면의 플랫폼 드롭다운 기본값 `'카페24'` 가
 * 오모플레이 경로에서도 그대로 저장되는 결함이 났다(OB-25).
 *
 * 서버 어휘와 **반드시 같은 문자열**이어야 한다 —
 * `headless-redirect-service` `libs/HostingName.kt`.
 *
 * 경위: `_ai-runs/2026-09-01_001_onboarding_hosting_name_cafe24_and_duplicate_channel/001_analysis.md`
 */

/** 오모플레이 제공 자사몰. `hosting_name` 은 `varchar(20)` 이라 5자는 여유가 있다. */
export const HOSTING_OMOPLAY = '오모플레이'

/** 카페24. 장바구니·CLV 조회가 가능한 유일한 플랫폼이다. */
export const HOSTING_CAFE24 = '카페24'

/**
 * 고객이 고를 수 있는 **외부 쇼핑몰** 종류.
 *
 * `value` 가 DB 에 그대로 저장되므로 문구만 바꿀 때도 `value` 는 건드리지 말 것 —
 * 서버 `SimpleScreenService` 가 이 문자열로 분기해 **고객 몰 페이지에 주입되는 JS** 를 만든다.
 */
export const HOSTING_MALL_PLATFORMS = [
    { label: '카페24 쇼핑몰 (cafe24.com)', value: HOSTING_CAFE24 },
    { label: '아임웹 쇼핑몰 (imweb.me)', value: '아임웹' },
    { label: '식스샵 쇼핑몰 (sixshop.com)', value: '식스샵' },
    { label: '고도몰 (NHN Commerce)', value: '고도몰' },
    { label: '기타 독립몰 (자체 개발 쇼핑몰)', value: '독립몰' },
]

/** 외부 쇼핑몰로 기록된 값인가(= 비어 있지 않고 오모플레이가 아닌가). */
export const isExternalMall = (hostingName) =>
    !!hostingName && hostingName !== HOSTING_OMOPLAY

/**
 * 화면 표시용 이름.
 *
 * 목록에 없는 낯선 값도 **원문을 그대로 보여준다** — 조용히 '알 수 없음' 으로 바꾸면
 * 관리자가 무엇을 확인해야 하는지 알 수 없다.
 */
export const hostingLabelOf = (hostingName) => {
    if (!hostingName) return '미지정'
    if (hostingName === HOSTING_OMOPLAY) return '오모플레이 제공 자사몰'
    return HOSTING_MALL_PLATFORMS.find((p) => p.value === hostingName)?.label ?? hostingName
}
